import {
 Box,
 Text,
 Flex,
 VStack,
 Heading,
 Divider,
 Image,
 Center,
 Button,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";
import { useRef } from "react";

const Receipt = () => {
 const location = useLocation();
 const queryParams = new URLSearchParams(location.search);

 const transactionId = queryParams.get("transactionId");
 const orderId = queryParams.get("orderId");
 const amount = queryParams.get("amount");
 const name = queryParams.get("name");
 const mobile = queryParams.get("mobile");
 const txnDate = new Date().toLocaleString();

 const receiptRef = useRef();

 const handleDownload = () => {
  const element = receiptRef.current;
  const opt = {
   margin: 0,
   filename: `LSSF_Receipt_${orderId}.pdf`,
   image: { type: "jpeg", quality: 0.98 },
   html2canvas: { scale: 2 },
   jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
  };
  html2pdf().from(element).set(opt).save();
 };

 return (
  <Box bg="#f5f5f5" minH="100vh" py={10} px={4}>
   <Box
    ref={receiptRef}
    maxW="500px"
    mx="auto"
    bg="white"
    boxShadow="lg"
    borderRadius="lg"
    overflow="hidden"
   >
    {/* Header */}
    <Box bg="#f68b1f" py={6} textAlign="center">
     <Center>
      <Image
       src="https://my-project-rql7.onrender.com/static/media/lss_logo.89bae2c852b508839c31.png"
       alt="Trust Logo"
       w="70px"
       mb={3}
      />
     </Center>
     <Heading fontSize="xl" color="white">
      LATE SURESH SINGH FOUNDATION <sup>®</sup> TRUST
     </Heading>
     <Text fontSize="sm" color="white">
      Society Prosperous - Country Prosperous
     </Text>
     <Text fontSize="xs" color="whiteAlpha.800">
      B-18, 3rd Floor, Satija House, Mukherjee Nagar, Delhi-110009
     </Text>
    </Box>

    {/* Payment info */}
    <Box textAlign="center" py={6}>
     <Heading size="lg" color="green.500">
      ₹{amount}
     </Heading>
     <Flex justify="center" align="center" mt={1}>
      <CheckCircleIcon color="green.500" mr={2} />
      <Text fontWeight="medium">Paid Successfully</Text>
     </Flex>
    </Box>

    <Divider borderColor="#f68b1f" />

    {/* Receipt details */}
    <Box px={8} py={6}>
     <VStack spacing={3} align="start" fontSize="sm">
      <Text>
       <strong>Transaction ID:</strong> {transactionId}
      </Text>
      <Text>
       <strong>Order ID:</strong> {orderId}
      </Text>
      <Text>
       <strong>Amount:</strong> ₹{amount}
      </Text>
      <Text>
       <strong>Status:</strong> Success
      </Text>
      <Text>
       <strong>Donor Name:</strong> {decodeURIComponent(name)}
      </Text>
      <Text>
       <strong>Donor Phone:</strong> {mobile}
      </Text>
      <Text>
       <strong>Transaction Date:</strong> {txnDate}
      </Text>
      <Text>
       <strong>Payment Mode:</strong> Razorpay
      </Text>
      <Text>
       <strong>Total Amount:</strong> ₹{amount}
      </Text>
     </VStack>
    </Box>

    <Divider />

    {/* Footer */}
    <Box textAlign="center" fontSize="xs" color="gray.600" py={4}>
     011-42875447 | 09910174777 | Info@lsstrust.in.org | www.lsstrust.org.in
    </Box>
   </Box>

   {/* Download Button */}
   <Center mt={6}>
    <Button colorScheme="orange" onClick={handleDownload}>
     Download Receipt
    </Button>
   </Center>
  </Box>
 );
};

export default Receipt;
